import { Backdrop, ButtonPrimary, Type } from '@spotify-internal/encore-web';
import { useTranslation } from 'react-i18next';

import { StyledDialogConfirmation } from './RateLimitingDialog.styles';

interface RateLimitingDialogProps {
  onCancel: () => void;
}

export default ({ onCancel }: RateLimitingDialogProps) => {
  const { t } = useTranslation('content_policy_reporting');

  return (
    <Backdrop center style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
      <StyledDialogConfirmation
        dialogTitle={t('rate_limited_dialog_title')}
        body={<Type as="p">{t('rate_limited_dialog_body')}</Type>}
        footer={<ButtonPrimary onClick={onCancel}>{t('rate_limited_dialog_button')}</ButtonPrimary>}
      />
    </Backdrop>
  );
};
